export default __webpack_public_path__ + "static/media/EraseIconPublic.62e50caf.svg";